import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summaryData: [],
};

const samplingTrackingSummarySlice = createSlice({
  name: "samplingTrackingSummary",
  initialState,
  reducers: {
    fetchSummary: (state, action) => {
      state.loading = true;
      state.error = null;
      state.summaryData = [];
    },
    fetchSummarySuccess: (state, action) => {
      state.loading = false;
      state.summaryData = action.payload?.data || [];
    },
    fetchSummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions, reducer } = samplingTrackingSummarySlice;
export const sliceKey = samplingTrackingSummarySlice.name;
